import type { SVGProps } from "react";
import * as React from "react";

const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      d="M17 2a1 1 0 1 0-2 0zm-2 4a1 1 0 1 0 2 0zM9 2a1 1 0 0 0-2 0zM7 6a1 1 0 0 0 2 0zM3 9a1 1 0 0 0 0 2zm18 2a1 1 0 1 0 0-2zM5 5h14V3H5zm14 0a1 1 0 0 1 1 1h2a3 3 0 0 0-3-3zm1 1v14h2V6zm0 14a1 1 0 0 1-1 1v2a3 3 0 0 0 3-3zm-1 1H5v2h14zM5 21a1 1 0 0 1-1-1H2a3 3 0 0 0 3 3zm-1-1V6H2v14zM4 6a1 1 0 0 1 1-1V3a3 3 0 0 0-3 3zm11-4v4h2V2zM7 2v4h2V2zm-4 9h18V9H3z"
    />
  </svg>
);
export default SvgCalendar;
